import script from "./nav-bar-routes.vue?vue&type=script&lang=js"
export * from "./nav-bar-routes.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__